import { render, staticRenderFns } from "./onboardingGuide.vue?vue&type=template&id=cc6646a8&scoped=true&"
import script from "./onboardingGuide.vue?vue&type=script&lang=js&"
export * from "./onboardingGuide.vue?vue&type=script&lang=js&"
import style0 from "./onboardingGuide.vue?vue&type=style&index=0&id=cc6646a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6646a8",
  null
  
)

export default component.exports